import {useCallback} from 'react';

import {SIGN_UP_EVENTS} from '@/app/auth/events/SignUpEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewSignUpPersonalInfo = useCallback(
    (
      invitationCode?: string,
      referralCode?: string,
      invitationCodeWritten?: boolean,
    ) => {
      trackEvent(SIGN_UP_EVENTS.VIEW_SIGNUP_PERSONAL_INFO, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        Invitation: {
          code: invitationCode,
          written: invitationCodeWritten,
        },
        user: {
          referral: {
            code: referralCode,
          },
        },
      });
    },
    [trackEvent],
  );

  const trackSelectSignUpPersonalInfoContinue = useCallback(
    (
      invitationCode?: string,
      referralCode?: string,
      invitationCodeWritten?: boolean,
    ) => {
      trackEvent(SIGN_UP_EVENTS.SELECT_SIGNUP_PERSONAL_INFO_CONTINUE, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        Invitation: {
          code: invitationCode,
          written: invitationCodeWritten,
        },
        user: {
          referral: {
            code: referralCode,
          },
        },
      });
    },
    [trackEvent],
  );

  const trackApiSignUpPersonalInfoError = useCallback(
    (
      invitationCode?: string,
      referralCode?: string,
      invitationCodeWritten?: boolean,
      error?: any,
    ) => {
      trackEvent(
        SIGN_UP_EVENTS.API_PRE_SIGN_UP_ERROR,
        {
          project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
          Invitation: {
            code: invitationCode,
            written: invitationCodeWritten,
          },
          user: {
            referral: {
              code: referralCode,
            },
          },
        },
        error,
      );
    },
    [trackEvent],
  );

  const trackViewSignUpEmailPassword = useCallback(
    (
      invitationCode?: string,
      referralCode?: string,
      invitationCodeWritten?: boolean,
    ) => {
      trackEvent(SIGN_UP_EVENTS.VIEW_SIGNUP_EMAIL_PASSWORD, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        Invitation: {
          code: invitationCode,
          written: invitationCodeWritten,
        },
        user: {
          referral: {
            code: referralCode,
          },
        },
      });
    },
    [trackEvent],
  );

  const trackSelectSignUpEmailPasswordContinue = useCallback(
    (
      invitationCode?: string,
      referralCode?: string,
      invitationCodeWritten?: boolean,
    ) => {
      trackEvent(SIGN_UP_EVENTS.SELECT_SIGNUP_EMAIL_PASSWORD_CONTINUE, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        Invitation: {
          code: invitationCode,
          written: invitationCodeWritten,
        },
        user: {
          referral: {
            code: referralCode,
          },
        },
      });
    },
    [trackEvent],
  );

  const trackSelectCheckboxOptInMarketingCampaigns = useCallback(
    (optIn: boolean) => {
      trackEvent(SIGN_UP_EVENTS.SELECT_CHECKBOX_OPT_IN_MARKETING_CAMPAIGNS, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        metadata: {
          marketing_opt_in: optIn,
        },
      });
    },
    [trackEvent],
  );

  const trackSelectSignUpGoToSignIn = useCallback(
    (
      invitationCode?: string,
      referralCode?: string,
      invitationCodeWritten?: boolean,
    ) => {
      trackEvent(SIGN_UP_EVENTS.SELECT_SIGNUP_GO_TO_SIGNIN, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        Invitation: {
          code: invitationCode,
          written: invitationCodeWritten,
        },
        user: {
          referral: {
            code: referralCode,
          },
        },
      });
    },
    [trackEvent],
  );

  return {
    trackViewSignUpPersonalInfo,
    trackSelectSignUpPersonalInfoContinue,
    trackApiSignUpPersonalInfoError,
    trackViewSignUpEmailPassword,
    trackSelectSignUpEmailPasswordContinue,
    trackSelectCheckboxOptInMarketingCampaigns,
    trackSelectSignUpGoToSignIn,
  };
};
